import { useEnvironmentInterface } from "environment-interface";
import type { CsbApi } from "environment-interface/csbApi";
import useSWR from "swr";

type State =
  | {
      state: "LOADING";
    }
  | { state: "ERROR"; error: string }
  | { state: "READY"; portalUrl: string };

type CustomerPortalOptions = {
  teamId?: string | null;
  returnPath?: string;
};
export const useCreateCustomerPortal = ({
  teamId,
  returnPath,
}: CustomerPortalOptions): State => {
  const { csbApi } = useEnvironmentInterface();

  const path = teamId
    ? `/v1/teams/${teamId}/customer_portal?return_path=${
        returnPath ?? `/dashboard?workspace=${teamId}`
      }`
    : null;
  const { data, error } = useSWR<{ stripeCustomerPortalUrl: string }>(
    path,
    (path) =>
      (csbApi as CsbApi).rest.get({
        path,
      }),
  );

  if (!data && !error) {
    return { state: "LOADING" };
  }

  if (error) {
    return { state: "ERROR", error: JSON.stringify(error?.message || error) };
  }

  const url = data?.stripeCustomerPortalUrl;

  if (!url) {
    return { state: "ERROR", error: "URL not found." };
  }

  return {
    state: "READY",
    portalUrl: url,
  };
};
